import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class Header extends Component {
	shouldComponentUpdate = ({
		headerText, headerTitle, cardVerification, invitedByUser,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.headerText, headerText)
			|| !isEqual(lastProps.headerTitle, headerTitle)
			|| !isEqual(lastProps.cardVerification, cardVerification)
			|| !isEqual(lastProps.invitedByUser, invitedByUser)
		);
	};

	render() {
		const {
			headerText, headerTitle, cardVerification, invitedByUser,
		} = this.props;
		return (
			<div>
				<div className="padding-left-25 padding-right-25 margin-top-20">
					<Choose>
						<When condition={headerTitle}>
							<h3 className="color-gray-bayoux font-size-25 font-semi-bold text-center">{ headerTitle }</h3>
							<p className="color-gray-cloud-burst font-regular font-size-16 text-justify">
								{ headerText }
							</p>
						</When>
						<Otherwise>
							<div className="padding-15">
								<span className="text-primary font-size-25 font-semi-bold">RKPay </span>
								<span className="color-gray-bayoux font-size-25 font-semi-bold">Sign Up</span>
								<div className="margin-top-10 padding-top-5 border-radius-20 height-30 width-fit-content bg-white-1">
									<span className="color-gray-cloud-burst font-size-16 font-regular">
										{`Pending invitation from ${invitedByUser}.`}
									</span>
								</div>
								<If condition={cardVerification}>
									<div className="margin-top-30">
										<p className="text-center">
											<img
												src="/images/checkmark.png"
												alt="checkmark"
											/>
										</p>
										<p className="color-gray-mine-shaft font-light font-size-16 text-center">
											Your credit card has been successfully added.
										</p>
									</div>
								</If>
							</div>
						</Otherwise>
					</Choose>
				</div>
				<div className="separator separator-blue" />
			</div>
		);
	}
}

Header.propTypes = {
	invitedByUser    : PropTypes.string.isRequired,
	headerText       : PropTypes.string,
	headerTitle      : PropTypes.string,
	cardVerification : PropTypes.bool,
};

Header.defaultProps = {
	headerText       : '',
	headerTitle      : '',
	cardVerification : false,
};

const mapStateToProps = ({ signup : { invitedByUser } }) => ({
	invitedByUser,
});

Header.propTypes = {
	headerText       : PropTypes.string,
	headerTitle      : PropTypes.string,
	cardVerification : PropTypes.bool,
	invitedByUser    : PropTypes.string,
};

Header.defaultProps = {
	headerText       : '',
	headerTitle      : '',
	cardVerification : false,
	invitedByUser    : '',
};

export default connect(mapStateToProps, null)(Header);
